




























import { defineComponent, PropType } from "@vue/composition-api";
import { UserPublicData, UserWithAvatar } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { getProfileUrl } from "@/lib/urlHelpers";
import { resolveUserName } from "@/lib/userHelpers";
import BaseAvatar from "@/components/BaseAvatar";

export default defineComponent({
  name: "UserBadgeWithAvatar",
  components: { BaseAvatar },
  props: {
    user: { type: Object as PropType<UserPublicData | UserWithAvatar | null> },
    subtitle: { type: String },
    to: { type: Object as PropType<Location> },
    clickableName: { type: Boolean, default: false },
    clickableAvatar: { type: Boolean, default: false },
    size: { type: [Number, String], default: 40 },
    hideOnlineStatus: { type: Boolean, default: false },
  },
  setup() {
    return {
      getProfileUrl,
      resolveUserName,
    };
  },
});
